<template>
  <div class="program-page">
    <div v-for="(item, index) in programList" :key="index" class="item-div">
      <p class="item-title" v-html="item.title"></p>

      <div>
        <div class="second img-right">
          <img :src="imageSrc(item.num)" alt="">
          <div class="desc-div">
            <p class="desc">{{item.desc}}</p>
            <ul>
              <li>
                <div><p>활동 시기 :&nbsp;</p></div>
                <div><p>{{item.date}}</p></div>
              </li>
              <li>
                <div><p>활동 장소 :&nbsp;</p></div>
                <div><p>{{item.place}}</p></div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CsrWhiteDragons',
  data() {
    return {
      programList: [],
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      this.programList = [
        {
          num: 7,
          title: '화이트 드래곤즈',
          desc: '”화이트 드래곤즈“는 선수들과 팬들이 일손이 필요하거나 봉사의 손길이 필요한 지역을 찾아 함께 봉사활동을 진행하는 프로그램입니다. 선수들과 팬들이 함께 지역을 위해 봉사활동도 하고 식사도 하며, 선수와 팬 모두에게 특별한 경험을 제공하는 프로그램입니다.',
          date: '09:00~14:00 (5~12월)',
          place: '전라남도 지역 내 복지기관 또는 도움이 \n필요한 단체',
        },
      ];
    },

    imageSrc(num) {
      return require(`@/assets/img/club/program_0${num}.png`);
    },
  },
};
</script>

<style scoped>
.total-year-records {
  padding-right: 0;
}

.total-year-records table {
  min-width: auto;
}

@media (max-width: 959px) {
  .total-year-records table {
    min-width: 800px;
  }
}
</style>
